import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Search } from "lucide-react";
import { api } from "../../lib/api";
import { fmtDate, fmtTRY } from "../../lib/format";

const SEGMENT_BADGE = { NEW: "bg-blue-500/15 text-blue-400", ACTIVE: "bg-emerald-500/15 text-emerald-400", RETURNING: "bg-violet-500/15 text-violet-400", INACTIVE: "bg-neutral-700 text-neutral-400" };
const SEGMENT_LABEL = { NEW: "Yeni", ACTIVE: "Aktif", RETURNING: "Sadık", INACTIVE: "Pasif" };

export default function CustomersPage() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    api.get(`/admin/customers?q=${encodeURIComponent(q)}&page=${page}&limit=30`)
      .then(({ data }) => setData(data)).catch(() => {});
  }, [q, page]);

  return (
    <div className="space-y-5" data-testid="admin-customers">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-display font-extrabold text-2xl text-white">Müşteriler <span className="text-sm text-neutral-500 font-normal">({data?.total ?? 0})</span></h1>
        <div className="relative">
          <Search size={15} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-neutral-500" />
          <input value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} placeholder="İsim veya e-posta..."
            className="h-10 pl-9 pr-4 bg-[#181B20] border border-[#272B33] rounded-xl text-sm text-white w-64 focus:outline-none focus:border-blue-500" data-testid="admin-customer-search" />
        </div>
      </div>
      <div className="bg-[#181B20] border border-[#272B33] rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]" data-testid="admin-customers-table">
          <thead>
            <tr className="text-left text-[11px] uppercase tracking-wider text-neutral-500 border-b border-[#272B33]">
              <th className="px-5 py-3.5">Müşteri</th><th className="px-4 py-3.5">Telefon</th>
              <th className="px-4 py-3.5">Sipariş</th><th className="px-4 py-3.5">Harcama</th>
              <th className="px-4 py-3.5">Son Sipariş</th><th className="px-4 py-3.5">Segment</th><th className="px-4 py-3.5 text-right"></th>
            </tr>
          </thead>
          <tbody>
            {data?.items?.map((c) => (
              <tr key={c.customer_id} className="border-b border-[#272B33]/50 hover:bg-[#1E222A]/50" data-testid={`customer-row-${c.email}`}>
                <td className="px-5 py-3">
                  <div className="flex items-center gap-3">
                    <div className="h-9 w-9 rounded-full bg-blue-600/15 text-blue-400 flex items-center justify-center font-bold text-sm overflow-hidden">
                      {c.picture ? <img src={c.picture} alt="" className="w-full h-full object-cover" /> : c.name?.[0]?.toLocaleUpperCase("tr-TR")}
                    </div>
                    <div>
                      <p className="text-white font-medium">{c.name}</p>
                      <p className="text-[11px] text-neutral-500">{c.email}</p>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3 text-neutral-400">{c.phone || "—"}</td>
                <td className="px-4 py-3 text-white font-semibold">{c.order_count}</td>
                <td className="px-4 py-3 text-white font-semibold">{fmtTRY(c.total_spent || 0)}</td>
                <td className="px-4 py-3 text-neutral-400 text-xs">{c.last_order_at ? fmtDate(c.last_order_at) : "—"}</td>
                <td className="px-4 py-3"><span className={`text-[10px] font-bold px-2 py-1 rounded-full ${SEGMENT_BADGE[c.segment] || ""}`} data-testid="customer-segment-badge">{SEGMENT_LABEL[c.segment] || "—"}</span></td>
                <td className="px-4 py-3 text-right">
                  <Link to={`/admin/musteriler/${c.customer_id}`} className="inline-flex p-2 rounded-lg text-neutral-400 hover:text-blue-400 hover:bg-blue-500/10" data-testid={`customer-detail-${c.customer_id}`}><ChevronRight size={16} /></Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {data?.items?.length === 0 && <p className="text-center text-neutral-500 text-sm py-12">Müşteri bulunamadı</p>}
      </div>
    </div>
  );
}
